<template>
  <div :class="killScroll ? 'stop' : ''">
    <!-- <the-top-bar showUser /> -->
    <calculator-loader v-if="showCalculator" />
    <helper-modal v-if="helper" />
    <app-search @state="searchState = $event" v-if="searchState" />
    <AppTour />

    <div ref="dialogComponent" :data-id="true" v-if="showingMessage"></div>
    <router-view />
    <!-- <support-form
      :in-view="hasSupport"
      v-if="user && $route.name !== 'admin'"
    /> -->
    <!-- <app-bottom-tab /> -->
  </div>
</template>

<script>
import "@/sass/_main.scss";
import Vue from "vue";
import AppTour from '@/components/AppTour.component.vue'
import TheTopBar from "@/components/TheTopBar";
import supportForm from "@/components/supportForm.component";
import AppBottomTab from "@/components/AppBottomTab";
import dialogComponent from "@/components/dialog.component";
import { mapActions, mapState } from "vuex";
import { getAuthenticatedUser, validateUser, logout } from "@/api/user.api";
import { getSurveys } from "@/api/survey.api";
import { getHelperDefinitions, getHelperFiles } from "@/api/helpers.api";
import Cookies from "js-cookie";
import HelperModal from "@/components/AppHelpers/HelperModal";
import CalculatorLoader from "@/components/CalculatorLoader";
import AppSearch from "@/components/AppHelpers/AppSearch";
export default {
  name: "App",
  components: {
    HelperModal,
    AppSearch,
    AppTour,
    CalculatorLoader,
    TheTopBar,
    dialogComponent,
    supportForm,
    AppBottomTab,
  },

  data() {
    return {
      searchState: false,
      showingMessage: false,
    };
  },
  mounted() {
    if (this.isFirstLoad) {
      const params = new URLSearchParams(document.location.search);
      const first = params.get("2b0d7b3dcb6d");

      if (first === "false") {
        this.setLogin({ user: false, isLogin: true });
        // this.$_validateUser();
        return;
      }

      this.$router.push({ name: "Welcome" });
    } else {
      this.$_validateUser();
    }
    this.$_getHelperDefinitions();
    this.$_getHelperFiles();
    //this.$appOffline();
  },
  watch: {
    killScroll: function (nV) {
      if (nV) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      ///remove for launch
      /*   if(this.$router.name !== 'Login' || this.$router.name !== 'Home'  || this.$router.name !== 'Welcome' ||  this.$router.name !== 'Register')
      {
        setTimeout(()=>{
          this.$appOffline()
          this.$router.push({name:'Home'})
      })
      } */
    },
    "$route.query.state": function (nV) {
      nV !== undefined && nV === "search"
        ? (this.searchState = true)
        : (this.searchState = false);
    },
    "dialog.active": function (nV) {
      if (nV) {
        this.showingMessage = true;
        setTimeout(() => {
          this.$_messageTrigger(this.dialog.data);
        });
        // this.$_messageTrigger(this.dialog.data)
      } else {
        this.showingMessage = false;
      }
    },
  },
  computed: {
    ...mapState({
      isFirstLoad: (state) => state.Main.isFirstLoad,
      helper: (state) => state.Helpers.helper,
      showCalculator: (state) => state.Main.showCalculator,
      dialog: (state) => state.sessions.dialog,
      user: (state) => state.User.user,
    }),
    hasSupport: {
      get() {
        return this.$route.name !== "adaptationPlan";
      },
    },
    killScroll: {
      get() {
        return (
          this.$route.query &&
          this.$route.query.state &&
          this.$route.query.state === "search"
        );
      },
    },
  },
  methods: {
    ...mapActions({
      setLogin: "User/SET_LOGIN",
      loadUserDefault: "User/loadDefault",
      loadSurveysDefault: "Surveys/loadDefault",
      setHelperDefinitions: "Helpers/setDefinitions",
      setHelperFiles: "Helpers/setFiles",
      updateUser: "User/updateUser",
    }),
    $appOffline() {
      let data = {
        title: ` Competition deadline is extended`,
        message: `
        <p> Good news! The Act to Adapt School Competition deadline is extended to October 31, 2021! Submitted entries can be updated before the Competition deadline.</p>
        <p>The SLDB Act to Act Team</p>`,
        //hasImage: '/img/banner-image@2x.cd301ba7.png',
        buttons: [
          {
            id: 0,
            value: "DISMISS",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },
        ],
        dataType: "",
      };
      this.$store.commit("TRIGGER_DIALOG", { data: data });
    },
    $_logout() {
      this.$store.commit("User/LOAD_DEFAULT");
      this.$store.commit("Surveys/LOAD_DEFAULT");
      logout().then((x) => {
        this.$router.push({ path: "/login" });
      });
    },
    $_getHelperDefinitions() {
      getHelperDefinitions()
        .then((res) => {
          const definitions = res.data.map((item) => {
            return {
              title: item.title.rendered,
              ...item.acf,
            };
          });

          this.setHelperDefinitions(definitions);
        })
        .catch((err) => {
          return err;
        });
    },
    $_getHelperFiles() {
      getHelperFiles()
        .then((res) => {
          const files = res.data.map((item) => {
            return {
              title: item.title.rendered,
              ...item.acf,
            };
          });

          this.setHelperFiles(files);
        })
        .catch((err) => {
          return err;
        });
    },
    $_getSurveys() {
      getSurveys(this.$store.state.User.user.id).then((res) => {
        //console.log(res);
      });
    },
    $_validateUser() {
      const token = Cookies.get("token");

      if (token) {
        validateUser()
          .then((res) => {
            getAuthenticatedUser({ token }).then((res) => {
              this.updateUser(res.data);

              /* this.$store.commit('Main/SET_FIRST_LOAD', false) */
            });
          })
          .catch(() => {
            Cookies.remove("token");
            this.loadUserDefault();
            this.loadSurveysDefault();
            if (this.$route.name !== "Login")
              this.$router.push({ name: "Login" });
          });
      } else {
        this.loadUserDefault();
        this.loadSurveysDefault();
        /* this.$store.commit('Main/SET_FIRST_LOAD', false) */
        /*  if (this.$route.name !== "Login") this.$router.push({ name: "Login" }) */
      }
    },
    $_messageTrigger(payload) {
      /*  let data = {
        title:payload.title,
        message: payload.message,
        buttons: [...payload.buttons],
        dataType: payload.dataType ? payload.dataType : ''
      } */
      this.dialogMessages(payload);
    },
    dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data,
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "message",
        },
        domProps: {
          innerHTML: data.message,
        },
      });
      let title = instance.$createElement("div", {
        attrs: {
          class: "context",
        },
        domProps: {
          innerHTML: data.title,
        },
      });

      instance.$slots.default = [link];
      instance.$slots.title = [title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700&display=swap');

html {
  background: #faf9fa;
  -webkit-tap-highlight-color: transparent;
}

#app {
  // height: 100vh;
  // width: 100vw;
  background: #faf9fa;

  // padding-bottom: 65px;
  &.stop {
    overflow: hidden;
    height: 100vh;
  }

  .impact-level-container {
    margin: 1rem 0 2rem 0;
    padding: 0 1rem;

    .text {
      font-weight: 600;
      font-size: 1.5em;
    }
  }
}

.shadow-depth {
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  &:hover {
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }
}

@media print {

  button,
  nav,
  .action-spacer {
    display: none !important;
  }
}</style>
